import React from 'react';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';

type PublishModalProps = {
  closeModal: () => void;
  confirmAction: () => void;
  id?: string;
  isProcessing?: boolean;
  isPublish?: boolean;
};

const FormThemePublishModal = ({
  closeModal,
  confirmAction,
  id,
  isProcessing = false,
  isPublish = false
}: PublishModalProps) => {
  const title = isPublish ? 'Publish Form Theme' : 'Unpublish Form Theme';
  const actionText = isPublish ? 'Publish' : 'Unpublish';
  const actionType = 'primary';
  const message = isPublish
    ? 'Publishing a theme makes it available in the list of selectable options in the form builder.'
    : 'Unpublishing a theme removes it from the list of selectable options in the form builder, but any existing forms using the theme will remain unaffected.';

  return (
    <Modal
      id={id}
      title={title}
      size="md"
      onClose={closeModal}
      onCancelClick={closeModal}
      actionButtonText={actionText}
      actionButtonType={actionType}
      onActionClick={confirmAction}
      isActionDisabled={isProcessing}
    >
      <div>{message}</div>
    </Modal>
  );
};

export default FormThemePublishModal;
